/* eslint-disable react/forbid-prop-types */
import React from 'react';

import PropTypes from 'prop-types';

import IntlMessages from '../../util/IntlMessages';

export default function LocaleMessage({ msg, ...rest }) {
    return <IntlMessages id={msg} {...rest} />;
}

LocaleMessage.defaultProps = {
    msg: 'default',
};

LocaleMessage.propTypes = {
    msg: PropTypes.string,
};
